import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoachAuthGuard } from './core/guards/coach-auth.guard';
import { CoachNoAuthGuard } from './core/guards/coach-no-auth.guard';
import { LoginComponent } from './views/login/login.component';
import { CoachLayoutComponent } from './views/layout/coach-layout/coach-layout.component';
import { PlaceholderComponent } from './views/placeholder/placeholder.component';
import { AccountComponent } from './views/account/account.component';
import { TicketsComponent } from './views/tickets/tickets.component';
import { AgendaComponent } from './views/agenda/agenda.component';
import { StudentsComponent } from './views/students/students.component';
import { MetricsComponent } from './views/metrics/metrics.component';
import { MessagesComponent } from './views/messages/messages.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'auth/login',
    canActivate: [CoachNoAuthGuard],
    component: LoginComponent,
  },
  {
    path: 'dashboard',
    canActivate: [CoachAuthGuard],
    component: CoachLayoutComponent,
    children: [
      {
        path: '',
        component: AgendaComponent,
        data: {titleKey: 'menu.agenda'},
      },
      {
        path: 'students',
        component: StudentsComponent,
        data: {titleKey: 'menu.students'},
      },
      {
        // The roster and the detail are one screen; the id only selects who the panel shows.
        path: 'students/:id',
        component: StudentsComponent,
        data: {titleKey: 'menu.students'},
      },
      {
        path: 'messages',
        component: MessagesComponent,
        data: {titleKey: 'menu.messages'},
      },
      {
        // The inbox and the open conversation are one screen; the id only selects the conversation.
        path: 'messages/:studentId',
        component: MessagesComponent,
        data: {titleKey: 'menu.messages'},
      },
      {
        path: 'exam-mentors',
        component: PlaceholderComponent,
        data: {titleKey: 'menu.exam_mentors'},
      },
      {
        path: 'reports',
        component: PlaceholderComponent,
        data: {titleKey: 'menu.reports'},
      },
      {
        path: 'metrics',
        component: MetricsComponent,
        data: {titleKey: 'menu.metrics'},
      },
      {
        path: 'tickets',
        component: TicketsComponent,
        data: {titleKey: 'menu.tickets'},
      },
      {
        path: 'account',
        component: AccountComponent,
        data: {titleKey: 'menu.account'},
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];

@NgModule({
  // Route data is bound to component inputs, so placeholder screens get their title key.
  imports: [RouterModule.forRoot(routes, {bindToComponentInputs: true})],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
